import React from 'react';

export const ListElement = ({ children, attributes, className, as = 'ul' }) => {
  const Component = as;
  return (
    <Component
      className={className}
      {...attributes}
    >
      {children}
    </Component>
  );
};
